import gql from 'graphql-tag'

const chatRoomStatus = gql`
  query {
    chatRoomStatus {
      id
      name
    }
  }
`

export default chatRoomStatus
